
/**
* Licensed Materials - Property of IBM
* IBM Cognos Products: ba-dashboard-livewidget
* (C) Copyright IBM Corp. 2018, 2022
* US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
*/
define({
	'pinLabel': 'Zakleni',
	'find_label': 'Najdi',
	'findCancelLabel': 'Prekliči',
	'dataPaneLabel': 'Podatki',
	'sourcePaneLabel': 'Izbrani izvori',
	'sourcePaneContentLabel': 'Izberi izvor',
	'emptySourcePaneTitle': 'Izberi izvor',
	'emptySourcePaneCaption': 'Kliknite izvor, da dodate podatke, ki jih želite uporabiti za gradnjo delovne table.',
	'addDataSource': 'Izberi izvor',
	'addDataDashboardCoachMarkContents': 'Povlecite in spustite podatke iz podokna s podatki v vašo delovno tablo.',
	'addDataStoryCoachMarkContents': 'Povlecite in spustite podatke iz podokna s podatki v zgodbo.',
	'addDataCoachMarkTitle': 'Dodaj podatke',
	'selectSourcesText': 'Izberite in dodajte izvor podatkov, da zgradite %{app}.',
	'selectSourcesLabel': 'Izberi izvor',
	'dataPreparationTitle': 'Priprava podatkov',
	'dataPreparationCaption': 'Podatki so prikazani tukaj, ko je priprava podatkov končana.',
	'dataPreparationProgress': 'Pripravljeno: %{percentage}% ...',
	'dataPreparationSourceError': 'Priprava podatkov za "%{sourceName}" ni bila uspešno dokončana.',
	'dataPreparationStarted': 'Priprava podatkov za "%{sourceName}" je v teku. Funkcije delovne table bodo na voljo, ko bo priprava podatkov končana.',
	'dataPreparationComplete': 'Priprava podatkov za "%{sourceName}" je dokončana. Zdaj je pripravljeno za uporabo z vsemi funkcijami delovne table.',
	'preparingData': 'Pripravljanje podatkov ...',
	'moserUnsupportedSourceType': 'Ta tip izvora podatkov ni podprt.',
	'errorSourcesTitle': 'Nalaganje podatkovnega drevesa ni uspelo',
	'errorLoadingDataSources': 'Med nalaganjem seznama naborov podatkov je prišlo do napake',
	'errorLoadingDataTree': 'Med nalaganjem drevesa je prišlo do napake',
	'dataSetPaneLastUpdated': 'Zadnja posodobitev: %{date}',
	'dataSourcePaneDateUnknown': 'Neznano',
	'moreTitle': 'Več',
	'backLabel': 'Pojdi nazaj',
	'addDataSourceDialogTitle': 'Izberi izvor',
	'addDataSourceDialogButtonLabel': 'Dodaj',
	'dlg_use': 'Uporabi',
	'dlg_RelinkDataSourceTitle': 'Zamenjaj nabor podatkov "%{dataSourceName}" s ...',
	'propertiesDialogTitle': 'Lastnosti',
	'missingDataSetData': 'Podatki za ta nabor podatkov niso na voljo. Osvežite nabor podatkov ali pa se za dostop do izvora obrnite na skrbnika.',
	'errorMessageTitle': 'Napaka',
	'calculation_navigation_in_use': 'Če izbrišete izračune, filtre ali navigacijske poti, se razveljavijo vse vizualizacije, ki se sklicujejo na izbrisano postavko. Ali ste prepričani, da želite izbrisati?',
	'delete_confirm': 'Potrdi brisanje',
	'previewUnavailable': 'Podatkovni pladenj in globalni filtri niso na voljo za ta tip paketa.',
	'contextualGridTabName': 'Podatki vizualizacije',
	'DATA_TRAY_no_data_text': 'Trenutno nimate nobenih podatkov',
	'contextualGridMenuLabel': 'Meni podatkov vizualizacije',
	'contextualGridExport': 'Izvozi',
	'nullValueText': 'Ničelno',
	'relationships_title': 'Razmerja',
	'forecastDetailsTabName': 'Napovedovanje statističnih podrobnosti',
	'forecastDetailsModelLabel': 'Model',
	'forecastDetailsQualityMetricLabel': 'Mere natančnosti',
	'forecastDetailsSmoothingCoefLabel': 'Parametri',
	'forecastDetailsDiagnostics': 'Diagnosticiranje',
	'forecastDetailsForecastLabel': 'Napoved',
	'forecastDetailsStatusLabel': 'Status',
	'forecastDetailsAccuracyPercentLabel': 'Odstotek natančnosti',
	'forecastDetailsTrendLabel': 'Trendni',
	'forecastDetailsSeasonLabel': 'Sezonskost',
	'forecastDetailsSeasonalPeriodLabel': 'Sezonsko obdobje',
	'forecastDetailsAlphaLabel': 'Alfa',
	'forecastDetailsBetaLabel': 'Beta',
	'forecastDetailsGammaLabel': 'Gama',
	'forecastDetailsPhiLabel': 'Fi',
	'forecastDetailsMissingCount': 'Manjka števec',
	'forecastDetailsSeriesLengthLabel': 'Dolžina serije',
	'forecastDetailsIgnoredPeriods': 'Prezrta obdobja',
	'forecastDetailsTrendStrength': 'Moč trenda',
	'forecastDetailsSeasonalityStrength': 'Moč sezonskosti',
	'forecastDetailsTimeDeltaUnit': 'Datumski/časovni interval',
	'forecastDetailsNotes': 'Opombe',
	'DatasetRefresh_AmbiguousConnection': ' Če želite razrešiti naslednjo težavo s povezavo, uporabite možnost \'Urejanje nabora podatkov\': %{errorMessage}'
});
